import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function Content19({data}) {
    const {content19Title, content19Text} = data
    return (
        <div className='our-imapct-video-wrap team-center-c-wrap light-grey-bg'>
            <div className='container sm-container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon'>
                            <StaticImage
                                src='../../../images/origins-icon.png'
                                alt='image'
                            />
                        </figure>
                        <h2 className='heading-level-4-i text-uppercase green-color-1'>
                            {content19Title && parser(content19Title)}
                        </h2>
                        {content19Text && parser(content19Text)}
                    </div>
                </div>

                <div className='team-nav-sec'>
                    <ul>
                        <li>
                            <Link to='#executive_team'>Executive Team</Link>
                        </li>
                        <li>
                            <Link to='#staff'>Staff</Link>
                        </li>
                        <li>
                            <Link to='#board-directors'>Board of Directors</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
